import React, { useState, useEffect } from 'react';
import Card from 'components/card';
import Switch from 'components/switch';
import styles from 'components/card-item-switch/index.module.scss';
import classNames from 'classnames/bind';
import alert from 'assets/icon_alert_red.svg';
import dayjs from 'dayjs';
import repo from '../../service/repository';
import { CITY_IDS } from 'config';

const cx = classNames.bind(styles);

/**
 * @param title {string}
 * @param switchState {'on','off','alert'}
 * @param subText {string}
 * @param isChecked {boolean}
 * @param onChange {function}
 * @param hasPayments {boolean}
 * @param enableAutoPayUpdatedAt {string}
 */

const CardItemSwitch = ({
  title,
  switchState = '',
  subText,
  hasPayments,
  isChecked = false,
  onChange,
  enableAutoPayUpdatedAt,
}) => {
  const [licensePlates, setLicensePlates] = useState([]);

  useEffect(() => {
    // If autoPay is off, do not fetch license plates
    if (!isChecked) return;
    const fetchData = async () => {
      try {
        const data = await repo.fetchLicensePlates();
        setLicensePlates(data);
      } catch (err) {
        console.log(err);
      }
    };

    fetchData();
  }, [isChecked]);

  const deregisteredLicensePlates = licensePlates.filter(({ onStreetParkingRegisters }) => {
    const newTaipeiCityRegistedState = (onStreetParkingRegisters ?? []).find(
      city => city.cityId === CITY_IDS.newTaipeiCity
    );

    return newTaipeiCityRegistedState?.state === 'deregistered';
  });

  const isDefaultConfigOn = isChecked && hasPayments;
  const isShowingLicensePlateErrorHint = deregisteredLicensePlates.length > 0;

  return (
    <Card className={styles['card']}>
      <div className={styles['switch-block']}>
        <div>
          <div className={styles['switch-title']}>
            {title}
            <SwitchState switchState={switchState} />
          </div>
          <div className={styles['sub-text']}>{subText}</div>
        </div>
        <div className={styles['switch-btn']}>
          <Switch isChecked={isChecked} onCheckChanged={onChange} />
        </div>
      </div>
      {isDefaultConfigOn && (
        <div className={styles.note}>
          將從 {dayjs(enableAutoPayUpdatedAt).format('YYYY.MM.DD')}{' '}
          起開立的停車單自動扣繳。因政府規定，逾期單、催繳單需自行人工繳費。
        </div>
      )}
      {isDefaultConfigOn && isShowingLicensePlateErrorHint && (
        <div className={styles['deregistered-error-hint']}>
          新北市綁定失敗：車牌 {deregisteredLicensePlates.map(({ plateNumber }) => plateNumber).join('、')}{' '}
          已綁定於其他支付平台，停車單將不會自動扣繳。
          {/* eslint-disable */}
          <a href="https://autopass.vip/4tEDf" target="_blank" rel="noopener">
            如何重新綁定
          </a>
        </div>
      )}
    </Card>
  );
};

const SwitchState = ({ switchState }) => {
  switch (switchState) {
    case 'on':
      return <span className={cx('switch-state', 'on')}>ON</span>;
    case 'off':
      return <span className={styles['switch-state']}>OFF</span>;
    case 'alert':
      return (
        <span className={cx('switch-state', 'alert')}>
          <img src={alert} alt="alert" />
        </span>
      );
    default:
      return <></>;
  }
};

export default CardItemSwitch;
